// extracted by mini-css-extract-plugin
export var icon = "_c1-3";
export var subtitle = "_c1-2";
export var title = "_c1-1";
export var value = "_c1-0";